import { IPromoPopup } from './promoPopup';
import { IPromoProp } from './promoProp';

export interface ILowRateMortgage {
  promos: ILowRateMortgagePromo[];
  title: string;
}

export interface ILowRateMortgagePromo {
  activeToDate: string;
  builderId: number;
  labels: ILowRateMortgagePromoLabel[];
  name: string;
  newbuildingIds: number[];
  promoProps: IPromoProp[];
  popup: IPromoPopup;
  providerLogo: string;
  providerName: string;
  providerPromoId: number;
  uniqueId: string;
}

export interface ILowRateMortgagePromoLabel {
  text: string;
  type: ELabelType;
}

export enum ELabelType {
  Mortgage = 'mortgage',
  Discount = 'discount',
  Bonus = 'bonus',
  NewbuildingCount = 'newbuildingCount',
}
